import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/master/course/page',
    info:'/api-ir/master/course/info/',
}

// 查询研究生课程表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

// 查询课程表详情
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
